(() => {
  if (window.TTGPlanSync && window.TTGPlanSync.initialized) {
    window.TTGPlanSync.syncAll();
    return;
  }

  const configurations = [
    {
      cardSelector: '[data-ttg-plan-value]',
      datasetKey: 'ttgPlanValue',
      radioSelector: '.ttg-primary-selector--stay input[type="radio"]'
    },
    {
      cardSelector: '[data-ttg-ticket-value]',
      datasetKey: 'ttgTicketValue',
      radioSelector: '.ttg-primary-selector--ticket input[type="radio"]'
    }
  ];

  const syncConfiguration = (configuration) => {
    const selected = document.querySelector(`${configuration.radioSelector}:checked`);
    document.querySelectorAll(configuration.cardSelector).forEach((card) => {
      const isSelected = Boolean(
        selected && selected.value === card.dataset[configuration.datasetKey]
      );
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', String(isSelected));
    });
  };

  const syncAll = () => {
    configurations.forEach(syncConfiguration);
  };

  window.TTGPlanSync = {
    initialized: true,
    syncAll
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const card = event.target.closest(
      '[data-ttg-plan-value], [data-ttg-ticket-value]'
    );
    if (!card) return;

    const configuration = configurations.find((item) => card.matches(item.cardSelector));
    if (!configuration) return;

    const value = card.dataset[configuration.datasetKey];
    const radio = Array.from(document.querySelectorAll(configuration.radioSelector))
      .find((item) => item.value === value);
    if (!radio) return;

    const label = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
    if (label) {
      label.click();
    } else {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    window.requestAnimationFrame(() => syncConfiguration(configuration));
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;

    const configuration = configurations.find((item) =>
      event.target.matches(item.radioSelector)
    );
    if (configuration) {
      window.requestAnimationFrame(() => syncConfiguration(configuration));
    }
  });

  document.addEventListener('shopify:section:load', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();
